export default function trackEvent(event, data) {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({
    event,
    ...data
  });
}